import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZoomOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconZoomOut"><Path fillRule="evenodd" clipRule="evenodd" d="M11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19C12.939 19 14.7178 18.3094 16.1023 17.162L20.0005 21.0602L21.0612 19.9996L17.1628 16.1012C18.3098 14.7169 19 12.9385 19 11C19 6.58172 15.4183 3 11 3ZM15 10.25V11.75H7V10.25L15 10.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconZoomOut;
